import { useElementSize } from 'hem-hooks';
import React, { useEffect, useRef } from 'react';

import {
  Carousel,
  CarouselApi,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '@/components/ui/carousel';
import { useWindowSize } from '@/hooks/useWindowSize';

type VariantCarouselProps = {
  slides: JSX.Element[];
  selectedIndex: number;
};

export const ProductRecommendationsCarousel: React.FC<VariantCarouselProps> = ({
  slides,
  selectedIndex,
}): JSX.Element => {
  const [api, setApi] = React.useState<CarouselApi>();

  const smallWidthRef = useRef();
  const largeWidthRef = useRef();
  const { width: windowWidth } = useWindowSize();
  const { width: smallWidth } = useElementSize(smallWidthRef);
  const { width: largeWidth } = useElementSize(largeWidthRef);
  const isLarge = windowWidth > 768;

  useEffect(() => {
    if (!api) {
      return;
    }

    api.reInit();
    api.scrollTo(0);
  }, [api, selectedIndex]);

  return (
    <>
      <div className="grid h-0 grid-cols-6 gap-2 md:grid-cols-12 md:gap-4">
        <div style={{ gridColumn: 'span 4' }} ref={smallWidthRef} />
        <div style={{ gridColumn: 'span 3' }} ref={largeWidthRef} />
      </div>

      <Carousel
        setApi={setApi}
        showMobileDots={false}
        opts={{
          loop: true,
          containScroll: false,
          align: (viewSize: number) => {
            const paddingInPixels = viewSize > 768 ? 48 : -24;
            return paddingInPixels;
          },
        }}
      >
        <CarouselContent className="ml-8">
          {slides.map((slide, index) => (
            <CarouselItem
              key={index}
              className="basis-auto pl-2 pt-2 md:pl-4 md:pt-4"
              style={{ width: isLarge ? largeWidth : smallWidth }}
            >
              {slide}
            </CarouselItem>
          ))}
        </CarouselContent>
        {isLarge && slides.length > 4 && (
          <>
            <CarouselPrevious className="hidden md:flex" />
            <CarouselNext className="hidden md:flex" />
          </>
        )}
      </Carousel>
    </>
  );
};
